import { SESSION_TIMEOUT } from "../../constants/sessionTimeout";

const timeoutRules = {
  initTime(time) {
    return time - SESSION_TIMEOUT.TIMER;
  },
  getElapseSecs(elapsed) {
    return Math.round(elapsed / SESSION_TIMEOUT.UPDATE_DELAY);
  },
  getElapse(start) {
    return new Date() - start;
  },
  hasTime(time) {
    return time >= 0 ? time : 0;
  }
};

/**
 * @name Timeout
 * @description
 * Util that handles the timeout the global timeout session counter
 * init function will start the timer based on the session response or a custom timeout value (if client uses applyCustomTimeout function)
 * when timeout is over, _timeOut function will run the callback provided by the client
 */
export const Timeout = {
  customTimeout: null,
  sessionSecs: null,
  sessionTimer: null,
  sessionElapsedSecs: 0,
  sessionStart: null,
  callbackFn: null,
  setCustomTimeout(customTimeout) {
    // Ensure that the requestedTimeout from the client is not exceeding the GMA timeout
    // Some brands might have flows with specific timeouts like CheckIn kiosk (enterprise web) or CDA (national web)
    const newTimeout = 
    customTimeout > SESSION_TIMEOUT.GMA_TIMEOUT ? SESSION_TIMEOUT.GMA_TIMEOUT : customTimeout;
    Timeout.customTimeout = newTimeout;
  },
  init(sessionTimeoutFromResponse, callback) {
    Timeout.callbackFn = callback;
    const sessionTimeout = Timeout.customTimeout ? Timeout.customTimeout : sessionTimeoutFromResponse;

    // Clear previous session interval (tick) if init was called again
    if (Timeout.sessionTimer) clearInterval(Timeout.sessionTimer);

    // Reducing the countdown time from session timeout value
    //  Since the final countdown modal is defaulted to count
    //  to 5 minutes, we reduce it from the total session timeout.
    let timeoutToModal = timeoutRules.initTime(sessionTimeout);
    Timeout.sessionSecs = timeoutRules.hasTime(timeoutToModal);

    if (Timeout.sessionSecs) {
      Timeout.sessionStart = Date.now();
      Timeout.sessionElapsedSecs = 0;
      Timeout.sessionTimer = setInterval(
        Timeout._tick,
        SESSION_TIMEOUT.UPDATE_DELAY
      );
    }
  },

  _tick() {
    const elapsed = timeoutRules.getElapse(Timeout.sessionStart);
    Timeout.sessionElapsedSecs = timeoutRules.getElapseSecs(elapsed);
    Timeout.sessionElapsedSecs >= Timeout.sessionSecs && Timeout._timeOut();
  },

  _timeOut() {
    clearInterval(Timeout.sessionTimer);
    Timeout.callbackFn();
  }
};
